module.exports = __webpack_public_path__ + "img/truck.310cb98d.svg";